import { format } from "@hejdoktor/resx-compiler"
export { format }
import { getLocale } from "@hejdoktor/resx-compiler"

import { R as _da } from "./Texts.da.resx"
import { R as _en } from "./Texts.en.resx"

type Translations = {
	"InsuranceProviderFreeAccess": string,
	"AdditionalServicesSelfPayment": string,
	"AdditionalServicesNotAvailable": string,
	"ReferralsHeading": string,
	"ReferralsCanBeReferredTo": string,
	"ReferralsSentViaXMedicus": string,
	"ReferralsPatientSendsCopy": string,
	"AdditionalInfoHeading": string,
}

const R = new Proxy({}, {
	get(target, name: keyof Translations, receiver) {
		if(process.env.enforcedLocale === "da" || (!process.env.enforcedLocale && getLocale("da") === "da")) {
			return _da[name] ?? name
		}

if(process.env.enforcedLocale === "en" || (!process.env.enforcedLocale && getLocale("da") === "en")) {
			return _en[name] ?? name
		}

		return name
	},
}) as Translations

export { R }